import { AxiosResponse } from 'axios'

import { ApiSecurityFilterWithDetail, Security } from 'types/security'
import { Cls1SecurityDetail, Cls2SecurityDetail } from 'types/securityDetail'

import { _axios } from './axios'

const FILTER = `/securities`
const FILTER_NAME_BY_SHIFT_QUESTIONNAIRE_TOKENS = `/securities/names`
const FILTER_WITH_DETAIL = `/securities/with_detail`
const SECURITY_ADD = `/securities`
const UPDATE = '/securities/update'
const BULK_DELETE = `/securities/bulk_delete`

export const securityApi = () => {
  const filter = async (): Promise<AxiosResponse<Security[]>> => {
    return await _axios()
      .get(FILTER)
      .then((x) => {
        x.data = x.data.securities
        return x
      })
  }

  const filterWithDetail = async (): Promise<
    AxiosResponse<ApiSecurityFilterWithDetail[]>
  > => {
    return await _axios()
      .get(FILTER_WITH_DETAIL)
      .then((x) => {
        x.data = x.data.securities
        return x
      })
  }

  const filterNameByShiftQuestionnaireTokens = async (
    tokens: string[],
  ): Promise<
    AxiosResponse<
      {
        firstName: string
        lastName: string
        token: string
      }[]
    >
  > => {
    return await _axios()
      .get(FILTER_NAME_BY_SHIFT_QUESTIONNAIRE_TOKENS, {
        params: { tokens },
      })
      .then((x) => {
        x.data = x.data.names
        return x
      })
  }

  const add = async (data: {
    security: Omit<Security, 'id'>
    cls1Detail: Cls1SecurityDetail
    cls2Detail: Cls2SecurityDetail
  }): Promise<AxiosResponse<void>> => {
    // 2号向けくもかんでは設定できる項目が少ない
    // 設定できない値はデフォルト値が入る

    const security = {
      // ベース 隊員情報
      firstName: data.security.firstName,
      lastName: data.security.lastName,
      code: data.security.originalCode,

      // cls2 隊員詳細
      email: data.cls2Detail.email,
      phone: data.cls2Detail.phoneNumber1,

      // cls1 隊員詳細
      maxRepeatedly: data.cls1Detail.maxRepeatedly,
      favoriteWorks: data.cls1Detail.favoriteWork,
      fixShifts: data.cls1Detail.fixShiftDays,
    }

    return await _axios()
      .post(SECURITY_ADD, security)
      .then((x) => {
        x.data = x.data.row
        return x
      })
  }

  const update = async (data: {
    security: Security
    cls1Detail: Cls1SecurityDetail
    cls2Detail: Cls2SecurityDetail
  }): Promise<AxiosResponse<void>> => {
    const security = {
      // ベース 隊員情報
      id: data.security.id,
      firstName: data.security.firstName,
      lastName: data.security.lastName,
      code: data.security.originalCode,

      // cls2 隊員詳細
      email: data.cls2Detail.email,
      phone: data.cls2Detail.phoneNumber1,

      // cls1 隊員詳細
      maxRepeatedly: data.cls1Detail.maxRepeatedly,
      favoriteWorks: data.cls1Detail.favoriteWork,
      fixShifts: data.cls1Detail.fixShiftDays,
    }

    return await _axios()
      .put(UPDATE, security)
      .then((x) => {
        x.data = x.data.row
        return x
      })
  }

  const bulkDelete = async (data: {
    securityIds: string[]
  }): Promise<AxiosResponse<void>> => {
    return await _axios().delete(BULK_DELETE, {
      data,
    })
  }

  return {
    filter,
    filterWithDetail,
    filterNameByShiftQuestionnaireTokens,
    add,
    update,
    bulkDelete,
  }
}
